import React, { FC, useState, useEffect } from 'react'
import classNames from 'classnames'
import styles from './SwipeLabelContainer.module.scss'

interface PropsType {
  isDisplayLeftLabel: boolean
  isDisplayRightLabel: boolean
}

const SwipeLabelContainer: FC<PropsType> = ({isDisplayLeftLabel, isDisplayRightLabel}) => {

  const leftLabelClassNames = classNames(styles.label, styles.skip, { [styles.isDisplay] : isDisplayLeftLabel })
  const rightLabelClassNames = classNames(styles.label, styles.read, { [styles.isDisplay] : isDisplayRightLabel })

  return (
    <div className={ styles.labelContainer }>
      <span className={leftLabelClassNames}>スキップ</span>
      <span className={rightLabelClassNames}>チェック</span>
    </div>
  )
}

export default SwipeLabelContainer